import { RouteCoords, RouteWaypoint } from "./types";

type MapCoordsCache = {
  pickup: RouteCoords | null;
  dropoff: RouteCoords | null;
  waypoints: Map<string, RouteCoords>;
};

export function createMapCoordsCache(): MapCoordsCache {
  return { pickup: null, dropoff: null, waypoints: new Map() };
}

export function rememberMapCoords(
  cache: MapCoordsCache,
  coords: {
    pickup: RouteCoords | null;
    dropoff: RouteCoords | null;
    waypoints: RouteWaypoint[];
  }
) {
  cache.pickup = coords.pickup;
  cache.dropoff = coords.dropoff;
  coords.waypoints.forEach((waypoint) => {
    if (waypoint.coords) cache.waypoints.set(waypoint.id, waypoint.coords);
    else cache.waypoints.delete(waypoint.id);
  });
}

export function clearMapPickup(cache: MapCoordsCache) {
  cache.pickup = null;
}

export function clearMapDropoff(cache: MapCoordsCache) {
  cache.dropoff = null;
}

export function clearMapWaypoint(cache: MapCoordsCache, waypointId: string) {
  cache.waypoints.delete(waypointId);
}

export function getMapCoordsForDisplay(
  cache: MapCoordsCache,
  coords: {
    pickup: RouteCoords | null;
    dropoff: RouteCoords | null;
    waypoints: RouteWaypoint[];
  }
) {
  return {
    pickup: coords.pickup ?? cache.pickup,
    dropoff: coords.dropoff ?? cache.dropoff,
    waypoints: coords.waypoints.map((waypoint) => ({
      ...waypoint,
      coords: waypoint.coords ?? cache.waypoints.get(waypoint.id) ?? null,
    })),
  };
}
